import React, { useEffect, useState } from "react";
import styles from "../Dashoard.module.css";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import DropdownMenu from "../../DropdownMenu/DropdownMenu";
import { useDispatch, useSelector } from "react-redux";
import { setActiveSelectedCourseIndex } from "../../../redux/dashboardSlice";
import EmptyCard from "../../EmptyCard/EmptyCard";
import { InfoIcon } from "../../../assets/icons/InfoIcon";

const CourseName = (props) => {
  const {
    singleCourseSalesInfo,
    allCoursesBasicInfoList,
    singleCourseEnrollmentInfo,
    setSelectedSingleCourseActive,
    hasCourses,
  } = props;

  const dispatch = useDispatch();
  const activeCourseId = useSelector((state) => state.dashboard.activeCourseId);
  const activeSelectedCourseIndex = useSelector(
    (state) => state.dashboard.activeSelectedCourseIndex
  );

  const [options, setOptions] = useState([]);
  const [activeOption, setActiveOption] = useState(null);

  useEffect(() => {
    if (
      activeSelectedCourseIndex !== null &&
      activeSelectedCourseIndex !== undefined
    ) {
      setSelectedSingleCourseActive(options[activeSelectedCourseIndex].key);
    } else if (activeCourseId >= 0 && options?.length > 0) {
      let foundIndex = options?.findIndex(
        (single) => single.key == activeCourseId
      );
      if (foundIndex > -1) {
        setSelectedSingleCourseActive(options[foundIndex].key);
      }
    }
  }, [activeSelectedCourseIndex, options, activeCourseId]);

  useEffect(() => {
    let newOptions = [];
    if (allCoursesBasicInfoList?.length > 0) {
      newOptions = allCoursesBasicInfoList?.map((singleCourseBasic, index) => {
        return {
          label: singleCourseBasic?.courseTitle,
          key: singleCourseBasic?.courseId,
          onChange: () => dispatch(setActiveSelectedCourseIndex(index)),
        };
      });
      setOptions(newOptions);
    }
  }, [allCoursesBasicInfoList]);

  return (
    <div
      className={styles.StatusSection}
      style={{
        height: "130px",
      }}
    >
      <div className={styles.StatusSectionHeader}>
        <h2 style={{ color: !singleCourseSalesInfo?.courseName && "#BBBFC9" }}>
          {singleCourseSalesInfo?.courseName || "Select course"}
        </h2>

        <DropdownMenu
          options={options}
          selected={
            activeOption
              ? options[activeOption]
              : options[
                  options?.findIndex((single) => single.key == activeCourseId)
                ]
          }
        />
      </div>
      {singleCourseSalesInfo?.courseName && (
        <div className={styles.StatusSectionInner}>
          <div className={styles.StatusCard}>
            <div className={styles.StatusCardTitle}>Sales</div>
            <div className={styles.StatusCardAmount}>
              {singleCourseSalesInfo?.totalSale
                ? `$${singleCourseSalesInfo?.totalSale}`
                : "$0"}
            </div>
            {singleCourseSalesInfo?.percentageDifference >= 0 &&
              singleCourseSalesInfo?.percentageDifference !== null && (
                <div className={styles.StatusCardChip}>
                  <span
                    className={
                      singleCourseSalesInfo?.isUpOrDown == "down"
                        ? styles.StatusCardChipRed
                        : styles.StatusCardChipGreen
                    }
                  >
                    {singleCourseSalesInfo?.isUpOrDown == "down" ? (
                      <ArrowDownwardIcon />
                    ) : (
                      <ArrowUpwardIcon />
                    )}
                    {singleCourseSalesInfo?.percentageDifference ||
                    singleCourseSalesInfo?.percentageDifference === 0
                      ? `${parseInt(
                          singleCourseSalesInfo?.percentageDifference
                        )}%`
                      : ""}
                  </span>
                </div>
              )}
          </div>

          <div className={styles.SP_line}></div>

          <div className={styles.StatusCard}>
            <div className={styles.StatusCardTitle}>Enrollment</div>
            <div className={styles.StatusCardAmount}>
              {singleCourseEnrollmentInfo?.totalEnrollments
                ? `${singleCourseEnrollmentInfo?.totalEnrollments}`
                : "$0"}
            </div>
            {singleCourseEnrollmentInfo?.percentageDifference >= 0 &&
              singleCourseEnrollmentInfo?.percentageDifference !== null && (
                <div className={styles.StatusCardChip}>
                  <span
                    className={
                      singleCourseEnrollmentInfo?.isUpOrDown == "down"
                        ? styles.StatusCardChipRed
                        : styles.StatusCardChipGreen
                    }
                  >
                    {singleCourseEnrollmentInfo?.isUpOrDown == "down" ? (
                      <ArrowDownwardIcon />
                    ) : (
                      <ArrowUpwardIcon />
                    )}
                    {singleCourseEnrollmentInfo?.percentageDifference ||
                    singleCourseEnrollmentInfo?.percentageDifference === 0
                      ? `${parseInt(
                          singleCourseEnrollmentInfo?.percentageDifference
                        )}%`
                      : ""}
                  </span>
                </div>
              )}
          </div>
        </div>
      )}
      {!singleCourseSalesInfo?.courseName && (
        <EmptyCard
          Icon={<InfoIcon />}
          description="Select a course to see data"
          showButton={false}
          BorderStatus="none"
          Padding="0px"
        />
      )}
    </div>
  );
};

export default CourseName;
